import { render, staticRenderFns } from "./drop-file.vue?vue&type=template&id=36e9df2b&scoped=true&"
import script from "./drop-file.vue?vue&type=script&lang=js&"
export * from "./drop-file.vue?vue&type=script&lang=js&"
import style0 from "./drop-file.vue?vue&type=style&index=0&id=36e9df2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e9df2b",
  null
  
)

export default component.exports